import { io, Socket } from 'socket.io-client';
import { config } from 'shared/config';
import { CalendarDayType } from '../interfaces/calendar-day.type';

type DayUpdateData = {
  type: 'full' | 'created' | 'updated' | 'deleted';
  data?: CalendarDayType;
  booking?: unknown;
  bookingId?: string;
};

type DayUpdateCallback = (data: DayUpdateData) => void;

class BookingSocketService {
  private socket: Socket | null = null;
  private isConnected = false;
  private dayData: CalendarDayType = [];
  private onDayUpdateCallback: DayUpdateCallback | null = null;

  connect = (
    pointId: string,
    date: string,
    onDayUpdate?: DayUpdateCallback
  ) => {
    this.disconnect();
    this.onDayUpdateCallback = onDayUpdate || null;

    const wsUrl = config.API_BOOKING?.replace('https://', 'wss://').replace(
      'http://',
      'ws://'
    );
    if (!wsUrl) return;

    const socket = io(`${wsUrl}/calendar`, {
      transports: ['websocket'],
      autoConnect: true,
    });

    socket.on('connect', () => {
      this.isConnected = true;
      socket.emit('subscribeDay', { pointId, date });
    });

    socket.on('dayUpdate', (data: DayUpdateData) => {
      if (data.type === 'full' && data.data) {
        this.dayData = data.data;
      }

      this.onDayUpdateCallback?.(data);
    });

    socket.on('disconnect', () => {
      this.isConnected = false;
      console.log('[BookingSocket] Disconnected');
    });

    socket.on('connect_error', (error) => {
      console.error('[BookingSocket] Connection error:', error);
    });

    this.socket = socket;
  };

  disconnect = () => {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    this.isConnected = false;
    this.dayData = [];
    this.onDayUpdateCallback = null;
  };

  getDayData = () => {
    return this.dayData;
  };

  get connected() {
    return this.isConnected;
  }
}

export const bookingSocketService = new BookingSocketService();
